module.exports = __webpack_public_path__ + "img/OPEN_NEW_TAB.22dfe397.svg";